<template>
  <div>
    <v-toolbar
      flat
      color="white"
    >
      <!-- <v-toolbar-title>My CRUD</v-toolbar-title> -->
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <!-- <v-divider
        class="mx-2"
        inset
        vertical
      ></v-divider> -->
      <v-spacer></v-spacer>
      <v-dialog
        v-model="dialog"
        max-width="500px"
        scrollable
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>add_circle_outline</v-icon>
        </v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex
                  xs12
                  sm12
                >
                  <!-- <v-text-field v-model="editedItem.name" label="Production No." required prepend-icon="select_all" ></v-text-field> -->
                  <v-autocomplete                    
                    hint="Atleast 3 Characters required"                    
                    :loading="loader"                   
                    flat
                    placeholder="Select only suggested Production No."
                    :items="cardTypes"
                    v-model="form.cardTypeId"
                    label="Production No."
                    auto
                    chips
                    prepend-icon="select_all"
                    required
                    item-text="name"
                    item-value="id"
                  ></v-autocomplete>

                </v-flex>
                <v-flex
                  xs12
                  sm12
                >
                  <v-text-field
                    v-model="editedItem.calories"
                    label="Item Name"
                    prepend-icon="drag_indicator"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                >
                  <v-text-field
                    v-model="editedItem.fat"
                    label="Batch No."
                    prepend-icon="horizontal_split"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md7
                >
                  <v-text-field
                    v-model="editedItem.carbs"
                    label="Components"
                    prepend-icon="settings_input_component"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md5
                >
                  <v-text-field
                    v-model="editedItem.protein"
                    label="QC no."
                    prepend-icon="supervised_user_circle"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    v-model="editedItem.protein"
                    label="Gross Weight (kg)"
                    prepend-icon="line_weight"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    v-model="editedItem.protein"
                    label="Net Weight (kg)"
                    prepend-icon="texture"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              outline
              @click.native="close"
            >Cancel</v-btn>
            <v-btn
              color="blue darken-1"
              outline
              @click.native="save"
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :search="search"
      class="elevation-1"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.calories }}</td>
        <td class="text-xs-left">{{ props.item.fat }}</td>
        <td class="text-xs-left">{{ props.item.carbs }}</td>
        <td class="text-xs-left">{{ props.item.protein }}</td>
        <td class="text-xs-left">{{ props.item.protein }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn
          color="primary"
          @click="initialize"
        >Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
    form: {
      cardNumber: 'SW Task',
      description: 'SW Task',
      cardName: 'Mcihael Wang',
      cardTypeId: 1,
      dueDate: '2018-04-09',
      tagid: [1],
      projectid: 1
    },
    cardTypes: [
      {
        id: 1,
        name: 'Arun'
      },
      {
        id: 2,
        name: 'Cheng'
      }
    ],
    search: '',
    headers: [
      {
        text: 'Production No.',
        align: 'left',
        sortable: false,
        value: 'ProdNo'
      },
      { text: 'Item Name', value: 'ItemName', align: 'left' },
      { text: 'Component', value: 'Component', align: 'left' },
      { text: 'QC No.', value: 'QCNO', align: 'left' },
      { text: 'Gross Weight', value: 'grossweight', align: 'left' },
      { text: 'Net Weight', value: 'netweight', align: 'left' },
      { text: 'Actions', value: 'name', sortable: false, align: 'left' }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      name: '',
      calories: '',
      fat: '',
      carbs: '',
      protein: ''
    },
    defaultItem: {
      name: '',
      calories: '',
      fat: '',
      carbs: '',
      protein: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    }
  },

  created () {
    this.initialize();
  },

  methods: {
    initialize () {
      this.desserts = [
        {
          name: 'Frozen Yogurt',
          calories: 'The standard data-table ',
          fat: 'Arun',
          carbs: 'Aravinth',
          protein: '2018-11-16'
        },
        {
          name: 'Ice cream sandwich',
          calories: 'The standard module ',
          fat: 'Sathish',
          carbs: 'Aravinth',
          protein: '2018-11-16'
        },
        {
          name: 'Eclair',
          calories: 'Sunward Project',
          fat: 'Arun',
          carbs: 'Cheng',
          protein: '2018-11-16'
        },
        {
          name: 'Cupcake',
          calories: 'The standard module ',
          fat: 'Arun',
          carbs: 'Sathish',
          protein: '2018-11-16'
        },
        {
          name: 'Gingerbread',
          calories: 'The standard module ',
          fat: 'Cheng',
          carbs: 'Aravinth',
          protein: '2018-11-16'
        },
        {
          name: 'Jelly bean',
          calories: 'The standard module ',
          fat: 'Arun',
          carbs: 'Aravinth',
          protein: '2018-11-16'
        },
        {
          name: 'Lollipop',
          calories: 'The standard module ',
          fat: 'Arun',
          carbs: 'Aravinth',
          protein: '2018-11-16'
        },
        {
          name: 'Honeycomb',
          calories: 'The standard module ',
          fat: 'Cheng',
          carbs: 'Sathish',
          protein: '2018-11-16'
        },
        {
          name: 'Donut',
          calories: 'The standard module ',
          fat: 'Arun',
          carbs: 'Aravinth',
          protein: '2018-11-16'
        },
        {
          name: 'KitKat',
          calories: 'The standard module ',
          fat: 'Arun',
          carbs: 'Aravinth',
          protein: '2018-11-16'
        }
      ];
    },

    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem (item) {
      const index = this.desserts.indexOf(item);
      confirm('Are you sure you want to delete this item?') &&
        this.desserts.splice(index, 1);
    },

    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/scrap/ScrapMaster.vue